import React, { useState, useRef } from 'react';
import './App.css';
import ImageTransformer from './components/ImageTransformer';
import ImageGallery from './components/ImageGallery';
import ImageModal from './components/ImageModal';

function App() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const galleryRef = useRef(null);

  const handleImageClick = (image) => {
    setSelectedImage({
      imageUrl: image.image_url,
      createdAt: image.created_at
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const handleDownload = async () => {
    if (!selectedImage?.imageUrl) return;

    try {
      const response = await fetch(selectedImage.imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = `niggified-${Date.now()}.png`;
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert('Failed to download image');
    }
  };

  const handleTransformComplete = () => {
    // Refresh gallery when a new image is generated
    if (galleryRef.current && galleryRef.current.refresh) {
      galleryRef.current.refresh();
    }
  };

  return (
    <div className="App">
      {/* Red background elements */}
      <div className="red-elements-container">
        <div className="red-circle red-circle-1"></div>
        <div className="red-circle red-circle-2"></div>
        <div className="red-circle red-circle-3"></div>
        <div className="red-circle red-circle-4"></div>
        <div className="red-stripe red-stripe-1"></div>
        <div className="red-stripe red-stripe-2"></div>
        <div className="red-blob red-blob-1"></div>
        <div className="red-blob red-blob-2"></div>
      </div>

      {/* Floating chicken emojis */}
      <div className="chicken-container">
        <span className="chicken chicken-1">🍗</span>
        <span className="chicken chicken-2">🍗</span>
        <span className="chicken chicken-3">🍗</span>
        <span className="chicken chicken-4">🍗</span>
        <span className="chicken chicken-5">🍗</span>
        <span className="chicken chicken-6">🐔</span>
        <span className="chicken chicken-7">🐔</span>
        <span className="chicken chicken-8">🍗</span>
        <span className="chicken chicken-9">🍗</span>
        <span className="chicken chicken-10">🐔</span>
        <span className="chicken chicken-11">🍗</span>
        <span className="chicken chicken-12">🐔</span>
        <span className="chicken chicken-13">🍗</span>
        <span className="chicken chicken-14">🍗</span>
        <span className="chicken chicken-15">🐔</span>
      </div>

      <header className="app-header">
        {/* Header floating animations */}
        <div className="header-floaters">
          <span className="header-float header-float-1">🍗</span>
          <span className="header-float header-float-2">🐔</span>
          <span className="header-float header-float-3">🍇</span>
          <span className="header-float header-float-4">🍗</span>
          <span className="header-float header-float-5">🥤</span>
          <span className="header-float header-float-6">🐔</span>
          <span className="header-float header-float-7">🍇</span>
          <span className="header-float header-float-8">🍗</span>
        </div>

        <h1 className="app-title">🍗 NIGGIFY 🍗</h1>
        <p className="app-subtitle">Finger Lickin' Good Transformations</p>
      </header>

      <main className="app-main">
        <ImageTransformer onTransformComplete={handleTransformComplete} />
        <ImageGallery ref={galleryRef} onImageClick={handleImageClick} />
      </main>

      {showModal && selectedImage && (
        <ImageModal
          image={selectedImage}
          onClose={handleCloseModal}
          onDownload={handleDownload}
        />
      )}

      <footer className="app-footer">
        <p>🍗 Powered by Colonel's Secret Recipe 🍗</p>
      </footer>
    </div>
  );
}

export default App;
